/**
 * created by lei lei
 *工作日程
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Calendar, Modal, Input, Button, message,} from 'antd';
import Card from "../../../components/card/Card";
import {Scrollbars} from "react-custom-scrollbars";
import * as utils from "../../../../utils";
import moment from 'moment';
import {params} from "../../../../utils";
import {permissionCheck} from "../../../../utils";
import {shrinNavigateStauts, updataNavigateData, updateNavigateLevel2Data} from "../../../../actions";
import {connect} from "react-redux";
import request from "../../../../base/request";
import {applicationName} from "../../../../utils";

class OrderDay extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            currentClick: '',
            visible: false,
            dataSource: [],
            value: moment(),
            modalList: [
                /* {title: '国庆节', type: 0},
                 {title: '运动会', type: 1},
                 {title: '拜访刘老师', type: 2},
                 {title: '国庆节', type: 3},
                 {title: '运动会', type: 1},
                 {title: '拜访刘老师', type: 2},
                 {title: '国庆节', type: 0},
                 {title: '运动会', type: 1},*/
            ],
            inputVal: ''
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        console.log(moment(), moment().format('YYYY-MM-DD HH:mm:ss'));
        this.getCalendarByYearAndMonth()
    }

    getCalendarByYearAndMonth() {
        let year = this.state.value.format('YYYY');
        let month = this.state.value.format('MM');
        let params = {
            year: year,
            month: month
        };
        getCalendarByYearAndMonth(params, res => {
            if (res) {
                this.setState({dataSource: res})
            }
        })
    }

    render() {
        let showSchoolCalendar = permissionCheck("pms:orderDaySchoolCalendar:viewBtn");//是否校历添加按钮和删除按钮
        return (
            <div style={{marginTop: 20}} className={'customCalender'}>
                <Card title={'工作日程'}>
                    <Calendar value={this.state.value} dateCellRender={this.dateCellRender} onSelect={(e) => {
                        this.dateSelect(e)
                    }} onChange={(e) => {
                        this.dateOnchange(e)
                    }}/>
                    <style>
                        {
                            `
                        .events {
                      list-style: none;
                      margin: 0;
                      padding: 0;
                    }
                    .events .ant-badge-status {
                      overflow: hidden;
                      white-space: nowrap;
                      width: 100%;
                      text-overflow: ellipsis;
                      font-size: 12px;
                    }
                    .notes-month {
                      text-align: center;
                      font-size: 28px;
                    }
                    .notes-month section {
                      font-size: 28px;
                    }
                    .customCalender .ant-radio-group{
                    display:none
                    }
                    .customCalender .ant-fullcalendar-content{
                    height:44px !important;
                     overflow-y: visible !important
                    }
                    .customCalender .ant-fullcalendar-date{
                    height:60px !important;
                   
                    }
                    `
                        }
                    </style>
                </Card>
                <Modal
                    title={this.state.currentClick}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={() => {
                        this.setState({visible: false})
                    }}
                    footer={null}
                >
                    <div style={{height: 250}}>
                        <Scrollbars>
                            <div style={{height: 250, paddingLeft: 20}}>
                                {
                                    this.state.modalList.map((item, i) => {
                                        let showDeleteBtn;
                                        let mark = '';
                                        let color = '';
                                        switch (item.type) {
                                            case 0:
                                                mark = '节日/节气';
                                                color = 'red';
                                                break;
                                            case 1:
                                                mark = '任务';
                                                color = '#faad14';
                                                showDeleteBtn = false;
                                                break;
                                            case 2:
                                                mark = '校历';
                                                color = 'green';
                                                showDeleteBtn = showSchoolCalendar;
                                                break;
                                            case 3:
                                                mark = '日程';
                                                color = 'blue';
                                                showDeleteBtn = true;
                                                break;
                                        }
                                        return (
                                            <div
                                                style={{display: 'flex', marginTop: 10, height: 32, lineHeight: '32px'}}
                                                key={i}>
                                                <div style={{width: 10, display: 'flex'}}>
                                                    <div style={{
                                                        width: 10,
                                                        height: 10,
                                                        borderRadius: 5,
                                                        background: color,
                                                        margin: 'auto'
                                                    }}></div>
                                                </div>
                                                <div style={{
                                                    paddingLeft: 10,
                                                    fontSize: 13,
                                                    fontWeight: 'bold', width: 300, overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap', cursor: 'pointer'
                                                }} title={item.name}>{item.name}</div>
                                                {showDeleteBtn ?
                                                    <Button type="primary" style={{marginLeft: 10}} onClick={() => {
                                                        this.delSchedule(item)
                                                    }}>删除</Button> : null}
                                            </div>

                                        )
                                    })
                                }
                            </div>
                        </Scrollbars>
                    </div>
                    <Input placeholder="请输入" value={this.state.inputVal} onChange={(e) => {
                        this.setState({inputVal: e.target.value})
                    }}/>
                    <div style={{textAlign: 'right', marginTop: 10}}><Button type="primary" onClick={() => {
                        this.addOrderDay(3)
                    }}>添加日程</Button> {showSchoolCalendar ? <Button type="primary" onClick={() => {
                        this.addOrderDay(2)
                    }}>添加校历</Button> : null}</div>
                </Modal>
            </div>
        )
    }

    //日期变化
    dateOnchange(e) {
        this.state.value = e;
        this.state.inputVal = '';
        this.getCalendarByYearAndMonth()
    }

    getListData = (value, title) => {
        let listData;
        let date = value.format('DD');//value.date();
        //moment().format('YYYY-MM-DD HH:mm:ss')
        let currentMonth = this.state.value.format('MM');
        let valMonth = value.format('MM');
        if (valMonth != currentMonth) {
            return [];
        }
        // console.log(currentMonth, valMonth, date)
        this.state.dataSource.forEach(item => {
            if (item.day == date) {
                listData = item.dayInfo;
            }
        });
        /*switch (date) {
            case 8:
                listData = [
                    {type: 'warning', content: 'This is warning event.'},
                    {type: 'success', content: 'This is usual event.'},
                ];
                break;
            case 10:
                listData = [
                    {type: 'warning', content: 'This is warning event.'},
                    {type: 'success', content: 'This is usual event.'},
                    {type: 'error', content: 'This is error event.'},
                ];
                break;
            case 15:
                listData = [
                    {type: 'warning', content: 'This is warning event'},
                    {type: 'success', content: 'This is very long usual event。。....'},
                    {type: 'error', content: 'This is error event 1.'},
                    {type: 'error', content: 'This is error event 2.'},
                    {type: 'error', content: 'This is error event 3.'},
                    {type: 'error', content: 'This is error event 4.'},
                ];
                break;
            default:
        }*/
        return listData || [];
    };
    getDayTitle = (value) => {
        let listData;
        let title;
        let date = value.format('DD');//value.date();
        //moment().format('YYYY-MM-DD HH:mm:ss')
        let currentMonth = this.state.value.format('MM');
        let valMonth = value.format('MM');
        if (valMonth != currentMonth) {
            return [];
        }
        this.state.dataSource.forEach(item => {
            if (item.day == date) {
                // listData = item.dayInfo;
                if (item.workholiday === '1') {
                    return title = '休'
                } else {
                    title = ''
                }
            }
        });

        return title;
    };

    dateCellRender = (value) => {
        const listData = this.getListData(value);
        const dayTitle = this.getDayTitle(value);
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        // if (listData.length > 0) {
        return (
            <div style={{
                height: 30, overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap', textAlign: 'center',
                background: listData.length > 0 && listData[0].checked ? newSecondSelectColor : '',
                color: listData.length > 0 && listData[0].checked ? 'white' : 'black', opacity: '0.3'
            }} title={listData.length && listData[0].name}>
                <div style={{color: 'red', position: 'absolute', top: 9}}>{dayTitle}</div>
                {listData.length > 0 ? listData[0].name : ''}
            </div>
            /*<ul className="events">
                {listData.map(item => (
                    <li key={item.content}>
                        <Badge status={item.type} text={item.content}/>
                    </li>
                ))}
            </ul>*/
        );
        // }

    };

    //点击日期每一项
    dateSelect(e) {
        //const listData = this.getListData(e);
        this.state.inputVal = '';
        let year = e.format('YYYY');//value.date();
        let month = e.format('MM');
        let day = e.format('DD');
        //console.log(year, month, day)
        let params = {
            year: year,
            month: month
        };
        let modalList = [];
        getCalendarByYearAndMonthWithoutLoading(params, res => {
            if (res && res.length > 0) {
                res.forEach(item => {
                    if (item.day == day) {
                        modalList = item.dayInfo?item.dayInfo:[];
                    }
                })
            }
            this.setState({currentClick: e.format('YYYY-MM-DD'), visible: true, modalList: modalList});
        });
    }

    addOrderDay(type) {
        let dateList = this.state.currentClick.split('-');
        let year = dateList[0];//this.state.currentClick.format('YYYY');
        let month = dateList[1];//this.state.currentClick.format('MM');
        let day = dateList[2];//;this.state.currentClick.format('DD');
        this.setState({visible: false});
        if (!this.state.inputVal.trim()) {
            message.info('请输入内容');
            return;
        }
        this.setState({visible: false});
        let params = {
            "year": year,
            "month": month,
            "day": day,
            "name": this.state.inputVal,
            "type": type
        };
        addSchedule(params, res => {
            if (res) {
                message.info('添加成功');
                this.state.inputVal = '';
                this.getCalendarByYearAndMonth()
            }
        })
    }

    //删除功能
    delSchedule(item) {
        let params = {id: item.id};
       // this.setState({visible: false});
        delSchedule(params, res => {
            if (res) {
                message.info('删除成功');
                this.state.inputVal = '';
                let currentClick=this.state.currentClick;

               /* let year = e.format('YYYY');//value.date();
                let month = e.format('MM');*/
                //console.log(year, month, day)
                let params = {
                    year: currentClick.split('-')[0],
                    month: currentClick.split('-')[1]
                };
                let modalList = [];
                getCalendarByYearAndMonth(params, res => {
                    if (res && res.length > 0) {
                        res.forEach(item => {
                            if (item.day == currentClick.split('-')[2]) {
                                modalList = item.dayInfo;
                                this.setState({ modalList: modalList});
                            }
                        })
                    }
                });
            }

        })
    }


}

function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(OrderDay);
const host = "/cm-sites-" + applicationName() + '/';
//获取工作日程列表
export const getCalendarByYearAndMonth = (body, callBack) => {
    request({url:host + "calendar/getCalendarByYearAndMonth", body, callBack, loading:false});
};
export const getCalendarByYearAndMonthWithoutLoading = (body, callBack) => {
    request({url:host + "calendar/getCalendarByYearAndMonth", body, callBack});
};
//添加日程/校历；
export const addSchedule = (body, callBack) => {
    request({url:host + "calendar/addSchedule", method:"post", body, callBack, loading:false});
};
//添加日程；
export const delSchedule = (body, callBack) => {
    request({url:host + "calendar/delSchedule", method:"post", body, callBack, loading:false});
};